import { createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import Mdx from "#/components/MdxRemote";
import { metadataToHead } from "#/lib/seo";

export default function Page() {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <main id="content" className="mx-auto mt-24 max-w-3xl space-y-10">
        <h1 className="text-center text-5xl">Cookie Policy</h1>

        <section className="mx-8 space-y-5">
          <Mdx source={content} />
        </section>
      </main>
      <Footer />
    </>
  );
}

const content = `
**Effective Date: January 31, 2024**

This Cookie Policy explains how Roamdoc ("we", "us", "our") uses cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are and why we use them, as well as your rights to control our use of them.

## 1. What are Cookies?

Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by online service providers to make their websites or services work, or to work more efficiently, as well as to provide reporting information.

## 2. Types of Cookies We Use

- **Essential Cookies:** These are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in, or filling in forms.
- **Preference Cookies:** These cookies remember your preferences and settings, such as your language or region, and personalize your experience on Roamdoc.
- **Analytics Cookies:** These cookies help us understand how our website is being used and how effective our marketing campaigns are. They help us customize our website for you.
- **Advertising Cookies:** Roamdoc uses these cookies to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing.
- **Social Media Cookies:** These cookies are set by a range of social media services that we have added to the site to enable you to share our content with your friends and networks.

## 3. How We Use Cookies

- **Enhancing Your Experience:** We use cookies to remember your login information and provide a secure and efficient experience navigating our site.
- **Tailored Job Recommendations:** Cookies help us show you jobs and content that we think you will be interested in.
- **Application Tracking:** We use cookies to streamline the application process and keep track of your application history.
- **Site Improvement:** By understanding how our site is used, we can improve the user experience for healthcare professionals like you.

## 4. Third-Party Cookies

In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the Service, deliver advertisements on and through the Service, and so on.

## 5. Your Choices and Consent

You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by clicking on the appropriate opt-out links provided in the cookie consent banner.

## 6. Changes to Our Cookie Policy

We may update this Cookie Policy from time to time. We encourage you to periodically review this page for the latest information on our cookie practices.

## 7. Contact Us

If you have any questions about our use of cookies or other technologies, please email us at [roamdoc.com/contact-roamdoc](https://roamdoc.com/contact-roamdoc).


---

*Please note that Roamdoc does not sell personal information. We value your privacy and strive to protect it.*

`;

export const metadata = {
  title: "Cookie Policy  • Roamdoc",
  description: "Cookie Policy for Roamdoc.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/cookie-policy`,
  },
};

export const Route = createFileRoute("/(legal)/cookie-policy/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
